<style>
.point_down {
  width: 100% !important;
  top: 0px;
  position: fixed;
  z-index: 9999;
}
</style>
<template>
  <div>
    <headerNav></headerNav>
    <img
      src="./../assets/images/point_down.png"
      v-show="showImg"
      class="point_down"
      @click="imgBtn"
    />
    <!-- <div class="center_box">
      <img src="./../assets/images/back.jpg" alt @click="test()" />
    </div> -->
    <div class="download_box">
      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/android.png" />
        </div>
        <div class="m_floatL download_text">
          <div>Dlabel安卓端下载</div>
          <div>{{ dateArr[1] | partFilter("") }}</div>
          <div>用于蓝牙版标签打印</div>
        </div>
        <div class="m_floatR download_down" @click="btnApk">
          <a>下载</a>
        </div>
      </div>
      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/iphone.png" />
        </div>
        <div class="m_floatL download_text">
          <div>Dlabel苹果端下载</div>
          <div>{{ dateArr[2] | partFilter("") }}</div>
          <div>蓝牙版标签打印,需ios10.3以上系统</div>
        </div>
        <div class="m_floatR download_down">
          <a href="https://dlabel.cn/ct">下载</a>
        </div>
      </div>

      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img src="./../assets/images/pc.png" />
        </div>
        <div class="m_floatL download_text">
          <div>Dlabel电脑端下载</div>
          <div>120.9MB {{ dateArr[0] | partFilter("") }}</div>
          <div>电脑端下载网址:https://dlabel.cn/ct</div>
        </div>
        <div class="m_floatR download_down">
          <a
            href="https://fileapp.ctaiot.com/dlabel/0/apply/b82baf3a-61e4-43b7-8ed5-4aa08f9c9cef.exe"
            >下载</a
          >
        </div>
      </div>

      <div class="m_clearLR download_div">
        <div class="m_floatL download_img">
          <img
            src="./../assets/images/ttl-logo.png"
            style="width:3.8rem;margin-right:0.4rem"
          />
        </div>
        <div class="m_floatL download_text">
          <div>驰腾贴贴乐移动端下载</div>
          <div>2021-06-01</div>
          <div>适用于家庭、办公、微小商户等场景</div>
        </div>
        <div class="m_floatR download_down">
          <a href="https://bsbapi.ctaiot.com/qrcode/QRcode.html">下载</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from "./header";
import { getVersionList } from "@/api/api";
import axios from "axios";
import qs from "qs";
export default {
  components: {
    headerNav: header
  },
  data() {
    return {
      showImg: false,
      date: "",
      dateArr: ["", "", ""],
      apk: "https://dlabel.cn/ct",
      textArr: [
        {
          // title:'Dlabel安卓端下载',
          // url:'http://39.108.49.16/media/app/app/Dlabel_112_1.apk',
          // size:'6.5MB'
        }
      ]
    };
  },
  created() {
    getVersionList().then(res => {
      var data = res.data.data;
      var temp = ["", "", ""];
      data.forEach(element => {
        if (element.equip === 3) {
          temp[0] = element.updateTime;
        } else if (element.equip === 1) {
          temp[1] = element.updateTime;
        } else if (element.equip === 2) {
          temp[2] = element.updateTime;
        }
      });
      this.dateArr = temp;
    });
    // axios.get("http://39.108.49.16/api/editor/version/").then(res => {

    //   // this.date = res.data[0].add_time.split("T")[0];
    // });
  },
  filters: {
    // 转化时间年月日
    partFilter: function(value, type) {
      if (!value) return "";
      var date = new Date(value);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      var second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d;
    }
  },
  methods: {
    test() {
      axios({
        method: "post", //请求方法
        data: qs.stringify({
          equip: 4,
          type: 6
        }),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: "https://bsbapi.ctaiot.com/api/data/down/time.json"
      }).then(res => {
        location.href =
          "https://shop128878083.youzan.com/v2/showcase/homepage?alias=wwV2bLjoYi";
      });
    },
    imgBtn() {
      this.showImg = !this.showImg;
    },
    isWeiXin() {
      // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase();
      // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    btnApk() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
      if (isAndroid) {
        // 这个是安卓操作系统
        if (this.isWeiXin()) {
          this.showImg = true;
        } else {
          location.href = this.apk;
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/software.vue